import { Navigate, useLocation, useParams } from 'react-router-dom';
import { PersonPageView } from '@/features/PersonPage';
import { AppRoutes } from '@/constants/routes';

export default function PersonPage() {
    const { personId } = useParams<{ personId: string }>();
    const location = useLocation();

    const locationState = location.state as Record<string, unknown> | null;
    const returnUrl =
        typeof locationState?.returnUrl === 'string'
            ? locationState.returnUrl
            : AppRoutes.PERSONS;

    if (!personId) {
        return <Navigate to={returnUrl} replace />;
    }

    return <PersonPageView personId={personId} returnUrl={returnUrl} />;
}
